// extracted by mini-css-extract-plugin
module.exports = {"container":"App_container__3dAQo","animatedBg":"App_animatedBg__203jC","image":"App_image__PWlvl","moveIcons":"App_moveIcons__2EcyV"};